import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useLocation } from "react-router-dom";
import ImageViewer from "../components/ImageViewer";
import '../css/header.css';

const API_BASE_URL = "https://apps.festivehq.com";

const BookViewer = () => {
  const { id } = useParams();
  const location = useLocation();
  const [images, setImages] = useState([]);
  const [showViewer, setShowViewer] = useState(true);

  // Read the bookPath from location state (passed from Library)
  const bookPath = location.state?.bookPath || `${API_BASE_URL}/apis/${id}.json`;

  useEffect(() => {
    const fetchImages = async () => {
      try {
        console.log("Fetching book JSON from:", bookPath);
        const res = await axios.get(bookPath);
        
        if (res.data?.images && Array.isArray(res.data.images)) {
          setImages(res.data.images);
          console.log("Images loaded:", res.data.images);
        } else {
          console.error("Invalid JSON structure:", res.data);
        }
      } catch (err) {
        console.error("Error fetching images:", err);
      }
    };

    if (id && bookPath) fetchImages();
  }, [id, bookPath]);

  return (
    <div className="min-h-screen bg-gray-100">
      {images.length > 0 && showViewer && (
        <ImageViewer 
          images={images} 
          productId={id}
          onExit={() => setShowViewer(false)} 
        />
      )}
    </div>
  );
};

export default BookViewer;
